import React, { useContext } from 'react';
import classNames from 'classnames';
import { get, isArray, isEmpty } from '@libs/shared';
import { PLUGIN_ARGUMENT_FIELD_TYPE, PLUGIN_ARGUMENT_VALUE_FROM } from '../../../interfaces';
import PluginDeptSelect from './components/plugin-dept-select';
import { PluginComponentContext } from '../plugin-component';
import FieldVariableSelect from '../field-variable-select';

interface IPluginDeptProps {
    entryId?: string;
}

interface DeptValue {
    departs?: string[];
}

/**
 * 插件-部门字段
 * @param props
 */
const PluginDept: React.FC<IPluginDeptProps> = () => {
    const pluginComponentStore = useContext(PluginComponentContext);

    if (!pluginComponentStore) {
        return null;
    }

    const { field, fieldValue, isView, checkStatusVisible, onChange } = pluginComponentStore;

    const renderContext = () => {
        const selectType = get(fieldValue, 'resolver_type', PLUGIN_ARGUMENT_VALUE_FROM.LITERAL);
        const { isRequired, isEnabled } = field;
        const value = fieldValue.resolver_arg;

        if (selectType === PLUGIN_ARGUMENT_VALUE_FROM.LITERAL) {
            const departs = (value as DeptValue)?.departs;
            return (
                <PluginDeptSelect
                    valuePanelClassName={classNames('value-panel', {
                        'is-error': checkStatusVisible && isRequired && isEmpty(departs)
                    })}
                    disabled={!isEnabled || isView}
                    defaultValue={departs}
                    onOk={(departs) => {
                        onChange(
                            isEmpty(departs)
                                ? undefined
                                : {
                                      departs
                                  }
                        );
                    }}
                />
            );
        }
        if (selectType === PLUGIN_ARGUMENT_VALUE_FROM.PROCESS_VAR) {
            return (
                <FieldVariableSelect
                    value={isArray(value) ? value : undefined}
                    argumentType={PLUGIN_ARGUMENT_FIELD_TYPE.DEPT}
                />
            );
        }
    };

    return <div className="fx-plugin-dept">{renderContext()}</div>;
};

export default PluginDept;
